import { z } from "zod";
import { IdSchema } from "./ids.js";
import { PermissionPatternSchema } from "./permissions.js";
import { VoiceSelectionSchema } from "./voice.js";
/** Model tiers; concrete model ids live in config per engine (DESIGN §6, §15). */
export const MODEL_TIERS = ["fast", "standard", "strong"];
export const ModelTierSchema = z.enum(MODEL_TIERS);
/**
 * A spending limit. `limitUsd: null` means unlimited. Subscription (notional) cost counts only
 * when `countNotional` is true, which is how usage-window limits are expressed.
 */
export const BudgetSchema = z.object({
    limitUsd: z.number().nonnegative().nullable(),
    period: z.enum(["run", "task", "day", "week", "month"]),
    countNotional: z.boolean(),
});
export const AgentKindSchema = z.enum(["assistant", "lead", "worker"]);
export const AgentDefSchema = z.object({
    id: IdSchema,
    kind: AgentKindSchema,
    companyId: IdSchema,
    roleId: IdSchema,
    instructions: z.string(),
    /** Capped by the role and by the requesting human's grants. */
    permissions: z.array(PermissionPatternSchema),
    budget: BudgetSchema,
    modelTier: ModelTierSchema,
    /** Set for personal assistants: the user they belong to. */
    ownerUserId: IdSchema.optional(),
    floorId: IdSchema.optional(),
    supervisorId: IdSchema.optional(),
    persona: z
        .object({
        name: z.string().min(1),
        voice: VoiceSelectionSchema.optional(),
        avatarRef: z.string().optional(),
    })
        .optional(),
});
//# sourceMappingURL=agent.js.map